import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Linqset, LINQSET_TYPE } from "../../common/linqset-model";
import { findTagForOrganisation, Tag } from "../../common/organisation";
import { v4 } from "uuid";

class Heading {
    public _key:string

    constructor(public label:string, public description:string) {
        this._key = v4()
    }
}

@Component({
    selector: 'app-linqset-card',
    templateUrl: './linqset-card.html',
    styleUrls: ['./linqset-card.css'],
    standalone: false
})
export class LinqsetCardComponent implements OnChanges{
    @Input() linqset:Linqset
    @Input() trigger:any

    headings:Heading[]

    modelNames:string
    modelFunctions:string
    modelTags:string
    assets:string
    nodeTags:string
    nodeNames:string

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes["trigger"] || changes["linqset"]) && this.linqset)
            this.setupData()
    }
   
    setupData() {
        this.headings = [new Heading("Organisation", this.linqset.organisation.name), new Heading("Workspace", this.linqset.workspaceName), new Heading("Name", this.linqset.name)]
        if (this.linqset.description.length > 0)
            this.headings.push(new Heading("Description", this.linqset.description))

        if (this.linqset.filter.modelFunctions.length > 0)
            this.headings.push(new Heading("Model functions", this.linqset.filter.modelFunctions.join(", ")))

        if (this.linqset.type === LINQSET_TYPE.MODEL || this.linqset.type === LINQSET_TYPE.ORGANISATION) {
            if (this.linqset.model.function) this.headings.push(new Heading("Model function", this.linqset.model.function))
            if (this.linqset.organisation.modelTags && this.linqset.model.tagKeys && this.linqset.model.tagKeys.length > 0) {
                this.headings.push(new Heading("Model function", this.linqset.model.tagKeys.map((tk:string) => this.linqset.organisation.modelTags.tags.find((t:Tag) => t._key === tk).name).join(", ")))
            }
            if (this.linqset.model.createdDate) {
                const d = new Date(this.linqset.model.createdDate)
                this.headings.push(new Heading("Created", d.toDateString()))
            }
            if (this.linqset.insights.updatedDate) {
                const d = new Date(this.linqset.insights.updatedDate)
                this.headings.push(new Heading("Last updated", d.toDateString()))
            }
        }

        if (this.linqset.filter.modelTags.length > 0)
            this.headings.push(new Heading("Model tags", this.modelTags = this.linqset.filter.modelTags.join(", ")))            

        if (this.linqset.modelKeys.length > 1)
            this.headings.push(new Heading("Models", this.linqset.models.map(m => m.name).join(", ")))

        if (this.linqset.filter.informationAssetKeys.length > 0 && this.linqset.organisation.informationAssets) {
            const list = []
            this.linqset.filter.informationAssetKeys.forEach(k => {
                const ia = this.linqset.organisation.informationAssets.find(ia => ia._key === k)
                if (ia) list.push(ia.name)
            })
            this.headings.push(new Heading("Information assets", this.assets = list.join(", ")))
        }

        if (this.linqset.filter.nodeTags.length > 0) {
            const list = []
            this.linqset.filter.nodeTags.forEach(tk => {
                const tagGroup = findTagForOrganisation(this.linqset.organisation, tk)
                if (tagGroup) list.push(tagGroup.tag.name)
            })
            this.headings.push(new Heading("Node tags", this.assets = list.join(", ")))
        }

        if (this.linqset.filter.nodeKeys.length > 0) {
            const list = []
            this.linqset.filter.nodeKeys.forEach(k => {
                const node = this.linqset.nodes.find(n => n._key === k)
                if (node) list.push(node.name)
            })
            this.headings.push(new Heading("Nodes", this.assets = list.join(", ")))
        }
    }
}